import { Stack } from '@mui/material'
import IconHelp from 'components/IconHelp'
import { memo } from 'react'
import { SectionTitle } from 'styles'

export const PlaceOrderTitle = memo(() => {
  return (
    <SectionTitle>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <span>Create Order</span>
        <span style={{ lineHeight: 0, color: 'rgba(149, 164, 173, 1)' }}>
          <IconHelp
            title={
              'When you place an order on ZKEX it is auto-signed by your uniquely generated Layer2 private key, which ensures security, while saving time by removing the need to web3 sign each order every time.'
            }
            placement="bottom-start"
          />
        </span>
      </Stack>
    </SectionTitle>
  )
})
